import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import {
	BasicSelect
} from 'vue-search-select';
import {
	Validator
} from 'vee-validate'

export default {
	name: 'mark-hub-stressed',
	components: {
		VueElementLoading,
		BasicSelect
	},
	props: [],
	data() {
		return {
			isLoading: false,
			rows: [],
			hublist: [],
			hubitem: {
				value: '',
				text: ''
			},
			hub: '',
			hubLoading: '',
			fromtime: '',
			totime: '',
			IsMarkHub: false,
			IsPDD: false,
			HubBaginTimeSlotDetails: [],
			createdbyemail: '',
			fullErrorMessage: '',
			IsUpdateBtn: false,
			disableaddbtn: 0,
			disableupdatebtn: 0
		}
	},
	computed: {},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.getHubList();
		this.createdbyemail = userdetail[0].email;
	},
	methods: {
		getHubList() {
			this.hubLoading = 'Loading Hub...'
			this.input = ({})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubLoading = ''
					var HubDetails = result.data.ResponseData
					for (var i = 0; i < HubDetails.length; i++) {
						this.hublist.push({
							"value": HubDetails[i].HubID,
							"text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
						})
					}
				}, error => {
					console.error(error)
				})
		},
		selectHub(hubitem) {
			this.hubitem = hubitem
			this.hub = this.hubitem.text
		},
		getHubBaginSlotList() {
			if (this.hub != "") {
				this.rows = []
				this.input = ({
					HubId: this.hubitem.value
				})
				this.isLoading = true;
				axios({
						method: 'POST',
						'url': apiUrl.api_url_hubops + 'hubbagintimeslot/details/get/byhubid',
						'data': this.input,
						headers: {
							'authorization': 'authkey xB84JJ89Hd25',
						}
					})
					.then(result => {
						this.isLoading = false;
						if (result.data.ResultCode == 100) {
							this.IsUpdateBtn = true
							this.HubBaginTimeSlotDetails = result.data.ResponseData.TimeSlot
							this.fullErrorMessage = ''
							if (result.data.ResponseData.IsStressedLocation == "1") {
								this.IsMarkHub = true;
							} else if (result.data.ResponseData.IsStressedLocation == "0") {
								this.IsMarkHub = false;
							}
							if (result.data.ResponseData.IsPDD == "1") {
								this.IsPDD = true;
							} else if (result.data.ResponseData.IsPDD == "0") {
								this.IsPDD = false;
							}
							if (this.HubBaginTimeSlotDetails.length > 0) {
								for (var i = 0; i < this.HubBaginTimeSlotDetails.length; i++) {
									this.rows.push({
										fromtime: this.HubBaginTimeSlotDetails[i].FromTime,
										totime: this.HubBaginTimeSlotDetails[i].ToTime
									});
								}
								if (this.chkRows() == false) {
									return false;
								}
							}
						} else {
							this.IsUpdateBtn = false;
							this.IsMarkHub = false;
							this.IsPDD = false;
							this.fullErrorMessage = result.data.ReturnMessage
							this.rows.push({
								fromtime: '',
								totime: '',
								fromtimeerr: '',
								totimeerr: '',
								invalidtotimeerr: ''
							});
							this.isLoading = false;
						}
					}, error => {
						this.isLoading = false;
						console.error(error);
					})
			} else {
				this.isLoading = false;
			}
		},
		addRow: function() {
			if (this.chkRows() == false) {
				return false;
			}
			this.rows.push({
				fromtime: '',
				totime: '',
				fromtimeerr: '',
				totimeerr: '',
				invalidtotimeerr: ''
			});
		},
		removeRow: function(index, id) {
			this.rows.splice(index, 1);
		},
		chkRows() {
			var regex = /^[0-9]{4}$/
			if (this.rows.length > 0) {
				for (var x = 0; x < this.rows.length; x++) {
					var isErr = 0;
					if (this.rows[x].fromtime.trim() == '') {
						this.rows[x].fromtimeerr = 'Enter From Time';
						isErr = 1;
					} else if (regex.test(this.rows[x].fromtime) == false) {
						this.rows[x].fromtimeerr = 'FromTime must be 4 digit';
						isErr = 1;
					} else if (this.rows[x].fromtime < 0) {
						this.rows[x].fromtimeerr = 'Minimum time should be 0000';
						isErr = 1;
					} else if (this.rows[x].fromtime > 2359) {
						this.rows[x].fromtimeerr = 'Maximum time should be 2359';
						isErr = 1;
					} else {
						this.rows[x].fromtimeerr = '';
					}

					if (this.rows[x].totime.trim() == '') {
						this.rows[x].totimeerr = 'Enter To Time';
						this.rows[x].invalidtotimeerr = '';
						isErr = 1;
					} else if (regex.test(this.rows[x].totime) == false) {
						this.rows[x].totimeerr = 'ToTime must be 4 digit';
						this.rows[x].invalidtotimeerr = '';
						isErr = 1;
					} else if (this.rows[x].totime < 0) {
						this.rows[x].totimeerr = 'Minimum time should be 0000';
						this.rows[x].invalidtotimeerr = '';
						isErr = 1;
					} else if (this.rows[x].totime > 2359) {
						this.rows[x].totimeerr = 'Maximum time should be 2359';
						this.rows[x].invalidtotimeerr = '';
						isErr = 1;
					} else if (this.rows[x].totime == 0) {
						this.rows[x].invalidtotimeerr = 'Invalid ToTime';
						this.rows[x].totimeerr = '';
						isErr = 1;
					} else if (this.rows[x].fromtime > this.rows[x].totime) {
						this.rows[x].totimeerr = 'ToTime should be greater than FromTime';
						this.rows[x].fromtimeerr = 'FromTime should be less than ToTime';
						isErr = 1;
					} else {
						this.rows[x].totimeerr = '';
						this.rows[x].fromtimeerr = '';
						this.rows[x].invalidtotimeerr = '';
					}
				}
				if (isErr == 1) {
					return false;
				}
			} else {
				return true;
			}
		},
		// checkFromTime() {
		//   for (var x = 0; x < this.rows.length; x++) {
		//     if (this.rows[x].fromtime > this.rows[x].totime) {
		//       this.rows[x].totimeerr = 'ToTime should be greater than FromTime';
		//     } else {
		//       this.rows[x].totimeerr = '';
		//     }
		//   }
		// },
		// checkToTime(){
		//   for (var x = 0; x < this.rows.length; x++) {
		//     if (this.rows[x].fromtime > this.rows[x].totime) {
		//       this.rows[x].fromtimeerr = 'FromTime should be less than ToTime';
		//     } else {
		//       this.rows[x].fromtimeerr = '';
		//     }
		//   }
		// },
		checkInvaliToTimeError() {
			for (var x = 0; x < this.rows.length; x++) {
				if (this.rows[x].totime == 0) {
					this.rows[x].invalidtotimeerr = 'Invalid ToTime';
					this.rows[x].totimeerr = '';
				} else {
					this.rows[x].invalidtotimeerr = '';
				}
			}
		},
		addTimeSlot() {
			if (this.hub == '') {
				return false;
			} else if (this.chkRows() == false) {
				return false;
			} else {
				var timearr = [];
				for (var x = 0; x < this.rows.length; x++) {
					timearr[x] = {
						FromTime: this.rows[x].fromtime,
						ToTime: this.rows[x].totime
					};
				}
				if (this.IsMarkHub == true) {
					if (this.rows.length == 0) {
						this.fullErrorMessage = 'Enter Time Slot details'
						return false;
					} else {
						this.fullErrorMessage = ''
					}
				}
				this.input = ({
					HubId: this.hubitem.value,
					IsStressedLocation: this.IsMarkHub == true ? "1" : "0",
					IsPDD: this.IsPDD == true ? "1" : "0",
					TimeSlot: timearr,
					CreatedBy: this.createdbyemail,
					UpdatedBy: this.createdbyemail
				})
				this.isLoading = true;
				axios({
						method: 'POST',
						'url': apiUrl.api_url_hubops + 'add/hubbagintimeslot/details',
						'data': this.input,
						headers: {
							'authorization': 'authkey xB84JJ89Hd25',
						}
					})
					.then(result => {
						if (result.data.ResultCode == 100) {
							//this.$alertify.success(result.data.message)
							this.$alert(result.data.ReturnMessage, "", "success");
							this.disableaddbtn = 1
							this.fullErrorMessage = ''
							// this.resetForm();
							this.isLoading = false;
						} else {
							this.disableaddbtn = 0;
							//this.$alertify.error(result.data.message);
							this.$alert(result.data.ReturnMessage, "", "error");
							this.isLoading = false;
						}
					}, error => {
						console.error(error);
						this.isLoading = false;
					})
			}
		},
		updateTimeSlot() {
			var timearr = [];
			if (this.chkRows() == false) {
				return false;
			} else {
				for (var x = 0; x < this.rows.length; x++) {
					timearr[x] = {
						FromTime: this.rows[x].fromtime,
						ToTime: this.rows[x].totime
					};
				}
				this.input = ({
					HubId: this.hubitem.value,
					IsStressedLocation: this.IsMarkHub == true ? "1" : "0",
					IsPDD: this.IsPDD == true ? "1" : "0",
					TimeSlot: timearr,
					CreatedBy: this.createdbyemail,
					UpdatedBy: this.createdbyemail
				})
				this.isLoading = true;
				axios({
						method: 'POST',
						'url': apiUrl.api_url_hubops + 'hubbagintimeslot/update/details/byhubid',
						'data': this.input,
						headers: {
							'authorization': 'authkey xB84JJ89Hd25',
						}
					})
					.then(result => {
						if (result.data.ResultCode == 100) {
							//this.$alertify.success(result.data.message)
							this.$alert(result.data.ReturnMessage, "", "success");
							this.disableupdatebtn = 1
							// this.resetForm();
							this.isLoading = false;
						} else {
							this.disableupdatebtn = 0;
							//this.$alertify.error(result.data.message);
							this.$alert(result.data.ReturnMessage, "", "error");
							this.isLoading = false;
						}
					}, error => {
						console.error(error);
						this.isLoading = false;
					})
			}
		},
		resetForm() {
			this.IsMarkHub = false;
			this.IsPDD = false;
			this.IsUpdateBtn = false;
			this.disableaddbtn = 0;
			this.disableupdatebtn = 0;
			this.hubitem = {
				value: '',
				text: ''
			};
			this.hub = '';
			this.fromtime = '';
			this.totime = '';
			this.rows = [];
			this.fullErrorMessage = '';
			this.$validator.reset();
			this.isLoading = false;
		},
		onSubmit: function(event) {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		}
	}
}


// WEBPACK FOOTER //
// ./src/views/components/MarkHubStressed/MarkHubStressed.js